<div class="addressList-container">
  <div class="addressList-header" [style.top]="isProfilePage ? '50px' : '124px'">
    <h1 class="addressList-title">{{'label.saved' | translate}}</h1>
    <app-button [blackTextButton]="true" [iconName]="'icon-square-add'" [buttonName]="'button.add'" class="addAddress-btn"
      (onClickEvent)="addNewAddress()"></app-button>
  </div>

  <div class="addressList-content" *ngIf="savedAddress?.length > 0">
    <div class="savedAddressList" *ngFor="let address of savedAddress; last as isLast" (click)="selectAddres(address)"
      [ngClass]="{'non-border-bottom' : isLast}">
      <i class="icon-home" *ngIf="address.addressIcon === addressType.home"></i>
      <i class="icon-work" *ngIf="address.addressIcon === addressType.work"></i>
      <i class="icon-rate-star" *ngIf="address.addressIcon === addressType.other"></i>

      <div class="savedAddressList-detail">
        <div class="savedAddressList-info">
          <div class="savedAddressList-title">
            <h1 class="title inputFielsTruncateText">{{address.addressDesc}}</h1>
            <span class="default-container" *ngIf="address.defaultFlag">{{'label.default' | translate}}</span>
          </div>

          <h1 class="truncateText">{{address.delAddress}}</h1>
          <h1 class="desc">{{'label.floor.unit' | translate}}: <span>{{address.delUnit ? address.delUnit : "-"}}</span>
          </h1>
          <h1 class="desc">{{'label.note.to.driver' | translate}}: <span>{{address.remarks ? address.remarks : "-"}}</span></h1>
        </div>

        <div class="action-container" *ngIf="!isCartPage">
          <app-button [blackTextButton]="true" [iconName]="'icon-edit'" (click)="$event.stopPropagation(); editAddress(address)"></app-button>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="savedAddress?.length == 0">
    <span class="no-saved-address-desc">{{'desc.no.saved.address' | translate}}</span>
  </div>
</div>
